var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnAttack = function SvgIcnAttack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 13.333H11.6667C9.83337 13.333 8.33337 14.833 8.33337 16.6663V33.333C8.33337 35.1663 9.83337 36.6663 11.6667 36.6663H28.3334C30.1667 36.6663 31.6667 35.1663 31.6667 33.333V16.6663C31.6667 14.833 30.1667 13.333 28.3334 13.333ZM21.6667 34.1663H18.3334V31.6663H21.6667V34.1663ZM21.6667 29.9997H18.3334C18.3334 27.4997 14.1667 24.9997 14.1667 21.6663C14.1667 18.4497 16.7834 15.833 20 15.833C23.2167 15.833 25.8334 18.4497 25.8334 21.6663C25.8334 24.9997 21.6667 27.4997 21.6667 29.9997ZM30 10.833H10C10 9.44967 11.1167 8.33301 12.5 8.33301H27.5C28.8834 8.33301 30 9.44967 30 10.833ZM28.3334 5.83301H11.6667C11.6667 4.44967 12.7834 3.33301 14.1667 3.33301H25.8334C27.2167 3.33301 28.3334 4.44967 28.3334 5.83301Z",
    fill: "#C6C8CC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAttack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_attack.c7dad57d.svg";
export { ForwardRef as ReactComponent };